import { Text } from 'blaze-ui/Text/Text'
import Styles from './ReviewRequestCard.module.scss'
import {
  InformalFeedbackRequest,
  InformalFeedbackReviewDismissReason,
  InformalFeedbackReviewState,
} from 'api/clients/InformalFeedbackRequestsClient'
import { ReviewerScore } from 'components/ReviewSummaryModal/ReviewersCard/ReviewScore'
import { pluralize } from 'utils'
import dayjs from 'dayjs'
import cx from 'classnames'
import { NotOpened, Viewed } from 'blaze-ui/icons/20'

const MAX_REVIEWERS = 6

interface Props {
  request: InformalFeedbackRequest
}

export const ReviewersList = ({ request }: Props) => {
  const reviews = request.reviews.filter(
    (review) => review.dismissed_reason !== InformalFeedbackReviewDismissReason.RemovedFromReview,
  )
  const last_viewed = request.last_viewed

  return (
    <>
      <div className={cx(Styles.reviewers, { [Styles.withMoreReviewers]: reviews.length > MAX_REVIEWERS })}>
        {reviews.slice(0, MAX_REVIEWERS).map((review) => (
          <div key={review.id} className={Styles.review}>
            <div key={review.id} className={Styles.reviewer}>
              <Text variant="secondary" color="var(--dark-80)" lineClamp={1}>
                {review.reviewer.display_name}
              </Text>
            </div>

            {review.state === InformalFeedbackReviewState.Pending ? (
              <>
                {!last_viewed[review.reviewer.id] ? (
                  <div className={Styles.reviewResult}>
                    <NotOpened />
                    <Text variant="secondary" color="var(--dark-60)">
                      Not opened
                    </Text>
                  </div>
                ) : (
                  <div className={Styles.reviewResult}>
                    <Viewed />
                    <Text variant="secondary" color="var(--dark-60)">
                      {`Viewed ${dayjs(last_viewed[review.reviewer.id]).format('MMM D')}`}
                    </Text>
                  </div>
                )}
              </>
            ) : (
              <ReviewerScore review={review} variant="secondary" />
            )}
          </div>
        ))}
      </div>
      {reviews.length > MAX_REVIEWERS && (
        <div className={Styles.moreReviewers}>
          <div className={Styles.counter}>+{reviews.length - MAX_REVIEWERS}</div>
          <Text variant="secondary" color="var(--dark-80)">
            more {pluralize('reviewer', reviews.length - MAX_REVIEWERS)}
          </Text>
        </div>
      )}
    </>
  )
}
